<template>
    <div class="container">
        <div class="row">
            <div class="four col-md-3">
                <div class="counter-box colored"> 
                    <i class="fas fa-file-invoice"></i>
                    <p>
                        {{registrationDueDate}}
                    </p>
                </div>
                <span>Registration Due Date</span>
            </div>

            <div class="four col-md-3">
                <div class="counter-box colored"> 
                    <i class="fas fa-oil-can"></i>
                    <p>
                        {{serviceDueDate}}
                    </p>
                </div>
                <span>Service Due Date</span>
            </div>

            <div class="four col-md-3">
                <div class="counter-box colored"> 
                    <i class="fas fa-car-crash"></i>
                    <p>
                        {{insuranceDueDate}}
                    </p>
                </div>
                <span>Insurance Due Date</span>
            </div>

            <div class="four col-md-3">
                <div class="counter-box colored"> 
                    <i class="fas fa-procedures"></i>
                    <p>
                        {{ctpInsuranceDueDate}}
                    </p>
                </div>
                <span>CTP Insurance Due Date</span>
            </div>

            
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="four col-md-3">
                <div class="counter-box colored"> 
                    <i class="fas fa-charging-station"></i>
                    <p>
                        {{tyrePressureDueDate}}
                    </p>
                </div>
                <span>Tyre Pressure Due Date</span>
            </div>

            <div class="four col-md-3">
                <div class="counter-box colored"> 
                    <i class="fas fa-charging-station"></i>
                    <p>
                        {{tyreRotationDueDate || NOT_SET}}
                    </p>
                </div>
                <span>Tyre Rotation Due Date</span>
            </div>
        </div>
    </div>
</template>

<script>
import { apiClient } from '../helpers/api-client';

export default {
    name: 'Vehicle',
    data() {
        return {
            healthMetrics: [],
            insuranceDueDate: null,
            registrationDueDate: null,
            serviceDueDate: null,
            ctpInsuranceDueDate: null,
            tyreRotationDueDate: null,
            tyrePressureDueDate: null
        }
    },
    created() {
        this.fetchVehicleHealth();
    },
    methods: {
        async fetchVehicleHealth() {
            const result = await apiClient(`vehicles/${this.$route.params.id}/maintenancelog`, 'GET');
            const NOT_SET = 'Not Set';
            const insurances = result.data.filter((health)=> health.type === 'Insurance'); 
            const registrations = result.data.filter((health)=> health.type === 'Registration');
            const services = result.data.filter((health)=> health.type === 'Service');
            const ctpInsurances = result.data.filter((health)=> health.type === 'CTP Insurance');
            const tyrePressures = result.data.filter((health)=> health.type === 'Tyre pressure');
            const tyreRotations = result.data.filter((health)=> health.type === 'Tyre rotation');

            this.insuranceDueDate = insurances && insurances.length > 0 ? insurances[0].dueTime: NOT_SET;
            this.registrationDueDate = registrations && registrations.length > 0 ? registrations[0].dueTime: NOT_SET;
            this.ctpInsuranceDueDate = ctpInsurances && ctpInsurances.length > 0 ? ctpInsurances[0].dueTime: NOT_SET;
            this.serviceDueDate = services && services.length > 0 ? services[0].dueTime: NOT_SET;
            this.tyreRotationDueDate = tyreRotations && tyreRotations.length > 0 ? tyreRotations[0].dueTime: NOT_SET;
            this.tyrePressureDueDate = tyrePressures && tyrePressures.length > 0 ? tyrePressures[0].dueTime: NOT_SET;
            
            
        }
    }
}
</script>

<style scoped>
.container {
    margin-top: 20px;
    margin-bottom: 20px;
}

.counter-box {
    display: block;
    background: #f6f6f6;
    padding: 40px 20px 37px;
    text-align: center;
    border: 1px solid #CCCCCC;
    margin-bottom: 30px;
    -webkit-box-shadow: 0 10px 6px -6px #777;
    -moz-box-shadow: 0 10px 6px -6px #777;
    box-shadow: 0 10px 6px -6px #777;
    border-radius: 5px;
}

.counter-box p {
    margin: 5px 0 0;
    padding: 0;
    color: #909090;
    font-size: 18px;
    font-weight: 500
}

.counter-box i {
    font-size: 60px;
    margin: 0 0 15px;
    color: #d2d2d2
}
</style>